import apis from '@/utils/apis';
import qs from 'qs';

export default {
  methods: {
    // 跳转工单详情
    toOrderDetail(row, options = {}) {
      this.jump('/workorder/workOrderDetail', {
        orderType: 'workOrder',
        caseOrderType: row.workOrderType,
        caseOrderId: row.caseOrderId,
        workOrderId: row.workOrderId,
        ...options,
      });
    },
    // 跳转案例订单详情
    toCaseOrderDetail(row) {
      this.jump('/workorder/caseOrderDetail', {
        orderType: 'caseOrder',
        caseOrderType: row.caseOrderType,
        caseOrderId: row.caseOrderId,
        workOrderId: row.workOrderId,
      });
    },
    // 跳转设备详情
    toDeviceDetail(row) {
      this.jump('/devicedetail', {
        deviceId: row.deviceId,
        parentPath: this.$route.fullPath,
      });
    },

    fixZero(num) {
      if (typeof num === 'string') {
        if (num.length > 1) {
          return num;
        }
        return ['0', num].join('');
      } else {
        if (num >= 10) {
          return num;
        }
        return ['0', num].join('');
      }
    },

    /**
     * 将时间戳格式化为 HH:MM
     * @param {Number} ms
     * @returns {String} HH:MM
     */
    formatHHMM(ms) {
      const s = Math.ceil(ms / 1000);
      const h = Math.floor(s / 3600);
      const m = Math.floor((s - h * 3600) / 60);
      const ret = [this.fixZero(h), this.fixZero(m)].join(':');
      return ret;
    },

    // 获取工单耗时
    getOrderPayTime(row) {
      if (row.workOrderTimeHhmm) {
        return row.workOrderTimeHhmm;
      }
      // 'Z'为了将后端返回的时间做成世界时间
      const finishTime = row.finishTime ? new Date(`${row.finishTime}Z`) : new Date();
      const startTime = new Date(`${row.gmtCreate}Z`);
      if (row.workOrderState >= this.dicMap.asm_work_order_state.resolved) {
        if (this.dicMap.asm_work_order_state) {
          const diff = finishTime.getTime() - startTime.getTime();
          return this.formatHHMM(diff);
        }
        return '';
      }
      const curTime = new Date().getTime();
      const diff = curTime - startTime.getTime();
      return this.formatHHMM(diff);
    },
    /**
     * 导出工单
     * @param {array} cols 表格列配置 必填
     * @param {boolean} isOrg 是否为组织（所有）必填
     * @param {string} type wait-待接单 ing-解决中  finish-已解决 必填
     * @param {object} formSearch 查询参数
     * @param {string} exportName 导出文件名称 非必填
     * @return {promise} promise
     */
    exportOrder(cols, isOrg, type, formSearch, exportName) {
      const param = {};
      Object.keys(this.formSearch).forEach((key) => {
        const val = this.formSearch[key];
        if (val) {
          param[key] = val;
        }
      });

      delete param.pageSize;
      delete param.pageNum;

      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });

      const config = [
        {
          api: apis.workOrderPageFinishExport,
          isOrg: false,
          type: 'finish',
          label: '我的已解决',
        },
        {
          api: apis.workOrderPageWaitExport,
          isOrg: false,
          type: 'wait',
          label: '我的待接单',
        },
        {
          api: apis.workOrderPageIngExport,
          isOrg: false,
          type: 'ing',
          label: '我的解决中',
        },
        {
          api: apis.WorkOrderPageMyUnsolvedExport,
          isOrg: false,
          type: 'unresolved',
          label: '我的未解决',
        },
        {
          api: apis.workOrderPageMyOrgWaitExport,
          isOrg: true,
          type: 'wait',
          label: '所有待接单',
        },
        {
          api: apis.workOrderPageOrgFinishExport,
          isOrg: true,
          type: 'finish',
          label: '所有已解决',
        },
        {
          api: apis.workOrderPageOrgIngExport,
          isOrg: true,
          type: 'ing',
          label: '所有解决中',
        },
        {
          api: apis.WorkOrderPageUnsolvedExport,
          isOrg: true,
          type: 'unresolved',
          label: '所有未解决',
        },
      ];
      const postConfig = config.find(item => item.isOrg === isOrg && item.type === type);

      const reqData = {
        exportName: exportName || postConfig.label,
        headerList: cols,
      };

      return this.$exportFliePost(`${postConfig.api}?${pathParms}`, reqData).catch(() => {
        this.$message.error('导出失败');
      });
    },
  },
  mounted() {
    this.getDicMap('asm_work_order_state');
  },
};
